import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password] as const

export type csapCredType = (typeof credentialTypes)[number]

export const csapDocumentTypes = [
  'invoice',
  'proof-of-delivery',
] as const satisfies readonly DocumentType[]

export const csap: CarrierDef<csapCredType> = {
  name: 'CSA Transportation',
  scac: 'csap',
  ltlServices: [{ id: 'standard', name: 'Standard' }],
  credentialTypes,
  legacyCredMap: userPassMap,
  engineLayers: ['documents'],
  documentTypes: csapDocumentTypes,
}
